<template>
  <div class="stepper" data-testid="stepper">
    <div
      v-for="(step, index) in steps"
      :key="index"
      class="stepper__segment"
      :class="{ 'stepper__segment--filled': step.filled }"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Stepper extends Vue {
  @Prop({ type: Number, required: true })
  public stepsCount!: number;

  @Prop({ type: Number, required: true })
  public currentStep!: number;

  public get steps() {
    return Array.from({ length: this.stepsCount }, (_, index) => ({
      filled: index < this.currentStep
    }));
  }
}
</script>

<style lang="less" scoped>
.stepper {
  display: flex;
  gap: 4px;
  width: 100%;

  &__segment {
    flex: 1;
    height: 4px;
    border-radius: @size-radius-x100;
    background-color: @brand-secondary-darken;
    transition: background-color 0.3s ease;

    &--filled {
      background-color: @brand-primary-darken;
    }
  }
}
</style>
